/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import * as React from 'react';
const OuiIconVisQueryPromql = ({ title, titleId, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.5 2c0 .022 0 .043-.002.064l1.559 1.04a1 1 0 1 1-.555.832l-1.559-1.04a.996.996 0 0 1-.702.07L7.466 4.741A1.001 1.001 0 0 1 6.5 6a1 1 0 0 1-.998-1.064l-1.559-1.04a1 1 0 1 1 .555-.832l1.559 1.04a.996.996 0 0 1 .702-.07l1.775-1.775A1.001 1.001 0 0 1 9.5 1a1 1 0 0 1 1 1Z" />
    <path d="M8.5 9a.5.5 0 0 1-1 0v-.5h-2V9a.5.5 0 0 1-1 0V7.5h-2V9a.5.5 0 0 1-1 0V7.2a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v.3h2V6.2a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7V7h2.3a.7.7 0 0 1 .7.7V9a.5.5 0 0 1-1 0V8h-2v1a.5.5 0 0 1-1 0V6.5h-2V9Z" />
    <path
      fillRule="evenodd"
      d="M1.6 10c-.331 0-.6.315-.6.704v3.592c0 .389.269.704.6.704h12.8c.331 0 .6-.315.6-.704v-3.592c0-.389-.269-.704-.6-.704H1.6Zm10.965.714v2.643c0 .474.327.857.73.857h1.035v-.571h-1.034c-.135 0-.244-.128-.244-.286v-2.643h-.487Zm-.73.929v2.046c.124.047.231.12.31.18a1.749 1.749 0 0 1 .207.193l.014.014.004.005.001.002h.001l-.172.203-.172.202v-.001l-.008-.008a1.15 1.15 0 0 0-.145-.134c-.102-.08-.205-.13-.284-.13h-.73c-.404 0-.73-.384-.73-.858v-1.714c0-.474.326-.857.73-.857h.243c.404 0 .73.383.73.857Zm-1.218 0c0-.158.11-.286.244-.286h.243c.135 0 .244.128.244.286v2h-.487c-.135 0-.244-.128-.244-.286v-1.714Zm-9.008-.857v3.5h.487v-1.143h.487c.403 0 .73-.384.73-.857v-.643c0-.474-.327-.857-.73-.857h-.974Zm.974 1.785h-.487v-1.214h.487c.134 0 .243.128.243.286v.643c0 .158-.109.285-.243.285Zm1.643 1.715H3.74v-2.5h.487v.167a.746.746 0 0 1 .365-.096h.305v.572H4.59c-.201 0-.365.191-.365.428v1.429Zm3.652 0v-1.668l.498.584c.095.112.249.112.344 0l.497-.584v1.668h.487v-2.012c0-.382-.393-.574-.623-.304l-.533.626-.533-.626c-.23-.27-.624-.078-.624.303v2.013h.487Zm-1.887-2.429c-.403 0-.73.384-.73.857v.643c0 .474.327.857.73.857h.244c.403 0 .73-.383.73-.857v-.643c0-.473-.327-.857-.73-.857H5.99Zm-.243.857c0-.158.109-.285.243-.285h.244c.134 0 .243.127.243.285v.643c0 .158-.109.286-.243.286H5.99c-.134 0-.243-.128-.243-.286v-.643Z"
      clipRule="evenodd"
    />
  </svg>
);
export const icon = OuiIconVisQueryPromql;
